export default __webpack_public_path__ + "static/media/customBrockenPng.6355640d.png";